import { useMemo } from 'react';
import { useDiagramStore } from '../../../stores/diagramStore';

export function useGraphBoundProcessIds(folderId?: string): Set<string> {
  const nodes = useDiagramStore((state) => state.nodes);

  return useMemo(() => {
    const ids = new Set<string>();

    for (const node of nodes) {
      const props = (node.props as Record<string, unknown> | undefined) ?? {};
      const attrs = (node.attrs as Record<string, unknown> | undefined) ?? {};
      const candidates = [props.graphBinding, attrs.graphBinding];

      for (const candidate of candidates) {
        const binding = candidate as
          | { kind?: string; folderId?: string | null; processId?: string }
          | undefined;
        if (
          binding?.kind === 'compass-process' &&
          binding.processId &&
          (!folderId || binding.folderId === folderId)
        ) {
          ids.add(binding.processId);
        }
      }
    }

    return ids;
  }, [nodes, folderId]);
}
